import styled from 'styled-components'
import { theme } from '../../styles/theme'

interface IContainer {
  selected: boolean;
}

export const Container = styled.ul`
  width: 100%;

  display: flex;
  align-items: center;

  list-style: none;
  border-bottom: 1px solid ${theme.colors.secondGray};
`

export const Item = styled.li<IContainer>`
  padding: 10px;

  cursor: pointer;
  font-family: ${theme.font.inter};
  font-weight: ${theme.font.normal};
  font-size: ${theme.font.sizes.normal};
  line-height: ${theme.font.sizes.medium};
  color: ${({ selected }) => (
    selected ? theme.colors.brown : '#828282'
  )};
  border-bottom: 1px solid ${({ selected }) => (
    selected ? theme.colors.brown : 'transparent'
  )};
`
